module.exports = __webpack_public_path__ + "img/banner_contactus.34217043.jpg";